'use strict';

angular.module('licensure.helpers')
    .factory('Permissions', ['$q', '$state', 'SecurityTemplatePermissions', '$rootScope', function ($q, $state, SecurityTemplatePermissions, $rootScope) {
        var permissions = null;
        var gettingPermissions = false;

        var getPermissions = function () {
            var d = $q.defer();

            if (permissions == null) {
                if (!gettingPermissions) {
                    gettingPermissions = true;
                    var arr = [];
                    SecurityTemplatePermissions.get(true).then(function (p) {
                        p.forEach(function (permission) {
                            if (permission.object != null && (arr[permission.object.state] == null || arr[permission.object.state] < permission.permission)) {
                                arr[permission.object.state] = permission.permission;
                            }
                        });

                        permissions = arr;
                        gettingPermissions = false;
                        $rootScope.$broadcast('SecurityTemplatePermissions:finish');

                        d.resolve(permissions);
                    });
                }
                else {
                    $rootScope.$on('SecurityTemplatePermissions:finish', function () {
                        d.resolve(permissions);
                    });
                }
            }
            else {
                d.resolve(permissions);
            }

            return d.promise;
        }

        return {
            view: function (state) {
                var d = $q.defer();
                
                if (state == null) {
                    state = $state.current.name;
                }
                
                getPermissions().then(function (permissions) {
                    d.resolve(($rootScope.userAccount != null && $rootScope.userAccount.super) || permissions[state] > 0)
                })

                return d.promise;
            },

            add: function (state) {
                var d = $q.defer();

                if (state == null) {
                    state = $state.current.name;
                }

                getPermissions().then(function (permissions) {
                    d.resolve(($rootScope.userAccount != null && $rootScope.userAccount.super) || permissions[state] > 2)
                })

                return d.promise;
            },

            edit: function (state) {
                var d = $q.defer();

                if (state == null) {
                    state = $state.current.name;
                }

                getPermissions().then(function (permissions) {
                    d.resolve(($rootScope.userAccount != null && $rootScope.userAccount.super) || permissions[state] > 1)
                })

                return d.promise;
            },

            delete: function (state) {
                var d = $q.defer();

                if (state == null) {
                    state = $state.current.name;
                }

                getPermissions().then(function (permissions) {
                    d.resolve(($rootScope.userAccount != null && $rootScope.userAccount.super) || permissions[state] > 3)
                })

                return d.promise;
            }
        }
    }])
;